module.exports = new function lightbox()
{

    var gridItem = $('.four-grid-item');
    var closeItem = $('.close-info');
    var gridWrap = $('.four-grid');
    var allInfoBoxes = $('.four-grid-hover');

    gridItem.on('click', function(e) {
        $(this).next().addClass('show-grid-hover');
        $(this).find('img').addClass('active-grid-item');
        gridItem.not($(this)).addClass('disabled-grid-item');

        if ( $(window).width() <= 500 ) {
            posDiv($(this), $(this).next());
        }
    });

    closeItem.on('click', function() {
        gridItem.next().removeClass('show-grid-hover');
        gridItem.find('img').removeClass('active-grid-item');
        gridItem.not($(this)).removeClass('disabled-grid-item');
    });

    $('.next-info').on('click', function (e) {
        e.preventDefault();

        if ( $(this).parent().parent().next().next().length == 0 ) {
            return;
        } else {
            $(this).parent().parent().removeClass('show-grid-hover');
            $(this).parent().parent().next().next().addClass('show-grid-hover');

            if ( $(window).width() <= 500 ) {
                posDiv($(this).parent().parent(), $(this).parent().parent().next().next());
            }
        }
    });

    $('.prev-info').on('click', function (e) {
        e.preventDefault();

        if ( $(this).parent().parent().prev().prev().length == 0 ) {
            return;
        } else {
            $(this).parent().parent().removeClass('show-grid-hover');
            $(this).parent().parent().prev().prev().addClass('show-grid-hover');

            if ( $(window).width() <= 500 ) {
                posDiv($(this).parent().parent(), $(this).parent().parent().prev().prev());
            }
        }
    })

    var posDiv = function (clicked, clickedChild) {
        var pos = clicked.position();
        var top = pos.top + 'px';

        clickedChild.css({
            'top': top,
        });
    };

}
